export const INQUIRY_OFFER_TYPE: number = 1;
export const INQUIRY_MODERATION_TYPE: number = 2;
export const INQUIRY_TYPE_RECRUIT: number = 1;
export const INQUIRY_STATUS_NOTIFICATIONS: number = 1;
